import React, { useState, useEffect } from "react"
import Collapse from "@material-ui/core/Collapse"
import ArrowDropDownIcon from "@material-ui/icons/ArrowDropDown"
import ArrowDropUpIcon from "@material-ui/icons/ArrowDropUp"
import IconButton from "@material-ui/core/IconButton"
import { getCardIcon } from "../../utils/utils"
import { useTranslation } from "react-i18next"
import { NegativeAnnotationsTable } from './NegativeAnnotationsTable'

export const NegativeAnnotationsCard = (props) => {

    const { t } = useTranslation()


    const [expanded, setExpanded] = useState(false)
    const [firstTime, setFirstTime] = useState(true)

    const { negative_annotations, isPDF } = props

    let initialExpand = negative_annotations.has_negative_annotations

    if (initialExpand !== expanded && firstTime === true) {
        setExpanded(initialExpand)
    }

    const handleExpand = (event) => {
        event.stopPropagation()
        setFirstTime(false)
        setExpanded(!expanded)
    }

    useEffect(()=>{
        if(isPDF){
            setExpanded(true)
        }
    }, [isPDF])

    return (
        <div className="avoidPageBreakInside analysisCard">
            <div style={{ display: "flex" }}>
                <div
                    className={["blueText", "subtitleSize", "bold"].join(" ")}
                    style={{ margin: "auto 0px" }}
                >
                    {t("Anotações Negativas")}
                </div>
                <div style={{ margin: "auto 10px" }}>
                    {getCardIcon(negative_annotations.has_negative_annotations)}
                </div>
                {negative_annotations.details?.length > 0 &&
                    <IconButton style={{ marginLeft: "auto" }} onClick={handleExpand}>
                        {expanded ? <ArrowDropUpIcon /> : <ArrowDropDownIcon />}
                    </IconButton>
                }
            </div>
            {negative_annotations.details?.length > 0 &&
                <Collapse in={expanded} timeout="auto" unmountOnExit>
                    <div
                        className={["normalText", "normalMediumSize", "internalCardContainer"].join(" ")}
                    >
                        <NegativeAnnotationsTable negative_annotations={negative_annotations.details} />
                    </div>
                </Collapse>
            }
        </div>
    )
}
